import { createApp, h } from 'vue'
import Message from './AppMessage.vue'
import i18n from '@/i18n'
interface MessageOptions {
  title?: string
  message?: string
  type?: 'success' | 'error' | 'info' | 'warning'
  config?: {
    showClose?: boolean
    showIcon?: boolean
    showCancel?: boolean
    showConfirm?: boolean
    cancelText?: string
    confirmText?: string
    confirmSuffixText?: string
  }
  timer?: number
  onCancel?: () => void
  onConfirm?: () => void
  onClose?: () => void
  slots?: {
    default?: any
    footer?: any
  }
}

export type MessageServiceType = (options: MessageOptions) => void

let appInstance: any = null
let app: ReturnType<typeof createApp> | null = null
const destroyApp = () => {
  // 从 DOM 中移除实例
  app?.unmount()
  appInstance = null

  // 移除临时的 div
  const div = document.querySelector('#message-container') as HTMLDivElement
  if (div) {
    document.body.removeChild(div)
  }
}
const MessageService = (options: MessageOptions) => {
  if (!appInstance) {
    app = createApp({
      render() {
        return h(
          Message,
          {
            ...options,
            onClose: () => {
              options?.onClose?.()
              destroyApp()
            },
            onCancel: () => {
              options?.onCancel?.()
              destroyApp()
            },
            onConfirm: () => {
              options?.onConfirm?.()
              destroyApp()
            }
          },
          options.slots
        )
      }
    })

    // 挂载到一个临时的 div 上
    const div = document.createElement('div')
    div.id = 'message-container'
    document.body.appendChild(div)
    appInstance = app.use(i18n).mount(div)
  }
}

export default MessageService
